import { call, fork, put, select, take } from 'redux-saga/effects';
import qs from 'qs';

import {
  logoutSucces,
  initialLoadProcessed,
  logout,
  showVerifyAfterSignIn,
  showPage,
} from './actions';

import { globalSlice } from './reducer';

import apiService from '../../api/apiServices/apiService';
import { history } from '../../main';
import { findStats } from '../StatPage/actions';
import { getPokersiteIdByPokersiteName } from '../StatPage/utils';
import type { UserDto as User } from '@poker-stats/contracts';
import { selectUser } from './selectors';
import { toast } from 'react-toastify';

function* watchLogout() {
  while (true) {
    yield take(logout.type);

    const { success } = yield call([apiService, apiService.logout]);

    if (success) {
      yield put(logoutSucces());
      history.push('/');
    }
  }
}

function* watchChangeUserAvailablePokersiteIds() {
  while (true) {
    const { payload }: ReturnType<typeof globalSlice.actions.changeRoomsToSearch> = yield take(
      globalSlice.actions.changeRoomsToSearch.type,
    );

    const user: ReturnType<typeof selectUser> = yield select(selectUser);

    if (!user) {
      continue;
    }

    const { success, reject }: { success: { payload: User }; reject: any } = yield call(
      [apiService, apiService.changeUserRoomsToSearch],
      user.id,
      payload,
    );

    if (success) {
      yield put(globalSlice.actions.changeRoomsToSearchSuccess(success.payload));
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

function* watchChangeAutopasteRoomPriority() {
  while (true) {
    const { payload }: ReturnType<typeof globalSlice.actions.changeAutopasteRoomPriority> =
      yield take(globalSlice.actions.changeAutopasteRoomPriority.type);

    const user: ReturnType<typeof selectUser> = yield select(selectUser);

    if (!user) {
      continue;
    }

    const { success, reject }: { success: { payload: User }; reject: any } = yield call(
      [apiService, apiService.changeAutopasteRoomPriority],
      user.id,
      payload,
    );

    if (success) {
      yield put(globalSlice.actions.changeAutopasteRoomPrioritySuccess(success.payload));
    }
    if (reject) {
      toast.error(reject.payload.message);
    }
  }
}

export default function* appSaga() {
  try {
    const { success } = yield call([apiService, apiService.user]);
    if (success) {
      yield put(showVerifyAfterSignIn(success.payload));
      if (history.location.pathname === '/') {
        history.push(`/statistics`);
      }

      if (history.location.pathname === '/') {
        const search = history.location.search;
        history.push(`/statistics${search}`);
      }

      if (history.location.pathname === '/statistics') {
        const querystring = qs.parse(history.location.search, {
          ignoreQueryPrefix: true,
        });

        if (querystring.playername && querystring.room) {
          const pokersiteId = getPokersiteIdByPokersiteName(querystring.room as string);
          if (pokersiteId) {
            yield put(showPage('StatPage'));
            yield put(
              findStats({
                playername: querystring.playername as string,
                pokersiteId,
              }),
            );
          }
        }
      }
    }
  } finally {
    yield put(initialLoadProcessed(true));
  }

  yield fork(watchLogout);
  yield fork(watchChangeUserAvailablePokersiteIds);
  yield fork(watchChangeAutopasteRoomPriority);
}
